import { redirectEpics } from "domain/redirect/redirectEpics";
import { toastEpics } from "domain/toast/toastEpics";
import { userEpics } from "domain/user/userEpics";
import { combineEpics } from "redux-observable";

export const rootEpic = combineEpics(
    userEpics,
    toastEpics,
    redirectEpics);
